import { CREATED, MODIFIED, REMOVAL, ERROR, VALIDATION_ERROR, FILE } from './messageTypes'

export const messages = {
  [CREATED]: { message: 'Criado com sucesso!' },
  [MODIFIED]: { message: 'Atualzado com sucesso!' },
  [REMOVAL]: { message: 'Removido com sucesso!' },
  [ERROR]: { message: 'Ocorreu um erro, tente novamente.' },
  [VALIDATION_ERROR]: { message: 'Há erros de validação, por favor preencha os campos corretamente!' },
  [FILE]: { message: 'Arquivos enviados com sucesso.' }
}
